import { makeStyles } from '@mui/styles';
import { pxToRem } from '../../theme/typography';

export const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(2),
    minHeight: '100vh',
  },
  noHolidays: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    flexDirection: 'column',
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  message: {
    marginTop: theme.spacing(2),
    fontWeight: 'bold',
  },
  infoMessage: {
    marginTop: theme.spacing(2),
    fontSize: pxToRem(14),
  },
  table: {
    minWidth: 650,
  },
  tableCell: {
    padding: theme.spacing(1),
  },
  headerCell: {
    fontWeight: 'bold',
    color: theme.palette.grey[900],
  },
  weekendRow: {
    backgroundColor: 'rgba(255, 231, 217, 0.8)', // #FFE7D9 with 0.5 opacity
  },
  upcomingIndicator: {
    width: '6px',
    height: '6px',
    backgroundColor: theme.palette.primary.main,
    borderRadius: '50%',
    display: 'inline-block',
    marginLeft: theme.spacing(0.5),
    marginBottom: theme.spacing(0.5),
  },
}));
